// Limpa o HTML do texto das Regras antes de mostrar (e antes de salvar).
// Só ficam formatações simples: negrito, itálico, sublinhado, listas, cores,
// marca-texto e as classes de brilho do manual (rg-...). Qualquer outra coisa
// (script, iframe, onclick, link javascript:) é removida.

const TAGS_OK = new Set(["B", "STRONG", "I", "EM", "U", "S", "STRIKE", "BR", "P", "DIV", "SPAN", "UL", "OL", "LI", "FONT"]);
const ESTILOS_OK = ["color", "background-color", "font-weight", "font-style", "text-decoration", "text-decoration-line"];

const valorSeguro = (v) => !/url\(|expression|javascript:|@import/i.test(String(v || ""));

const limparElemento = (el, doc) => {
  Array.from(el.childNodes).forEach((filho) => {
    if (filho.nodeType === 3) return; // texto
    if (filho.nodeType !== 1) {
      filho.remove(); // comentários etc.
      return;
    }
    limparElemento(filho, doc);
    if (!TAGS_OK.has(filho.tagName)) {
      // Tag não permitida: fica só o conteúdo dela (sem a tag)
      if (/^(SCRIPT|STYLE|IFRAME|OBJECT|EMBED|svg|SVG|MATH|TEMPLATE)$/.test(filho.tagName)) {
        filho.remove();
        return;
      }
      while (filho.firstChild) el.insertBefore(filho.firstChild, filho);
      filho.remove();
      return;
    }

    // <font color="..."> (Chrome antigo) vira <span style="color:...">
    let alvo = filho;
    if (filho.tagName === "FONT") {
      const span = doc.createElement("span");
      const cor = filho.getAttribute("color");
      if (cor && valorSeguro(cor)) span.style.color = cor;
      while (filho.firstChild) span.appendChild(filho.firstChild);
      el.replaceChild(span, filho);
      alvo = span;
    }

    const estilos = [];
    ESTILOS_OK.forEach((prop) => {
      const v = alvo.style ? alvo.style.getPropertyValue(prop) : "";
      if (v && valorSeguro(v)) estilos.push(`${prop}: ${v}`);
    });
    const classes = String(alvo.getAttribute("class") || "")
      .split(/\s+/)
      .filter((c) => /^rg-[a-z0-9-]+$/.test(c));

    Array.from(alvo.attributes).forEach((a) => alvo.removeAttribute(a.name));
    if (estilos.length) alvo.setAttribute("style", estilos.join("; "));
    if (classes.length) alvo.setAttribute("class", classes.join(" "));
  });
};

export const sanitizarHtml = (html) => {
  if (!html) return "";
  try {
    const doc = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html");
    const raiz = doc.body.firstChild;
    limparElemento(raiz, doc);
    return raiz.innerHTML;
  } catch (e) {
    return "";
  }
};

export const textoPuro = (html) => {
  try {
    const doc = new DOMParser().parseFromString(`<div>${html || ""}</div>`, "text/html");
    return doc.body.textContent || "";
  } catch (e) {
    return "";
  }
};

/** Link do YouTube -> link de incorporar. Outros links ficam como estão. */
export const linkDeVideo = (url) => {
  const u = String(url || "").trim();
  const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/i);
  if (yt) return { tipo: "youtube", src: `https://www.youtube-nocookie.com/embed/${yt[1]}` };
  const vimeo = u.match(/vimeo\.com\/(\d+)/i);
  if (vimeo) return { tipo: "youtube", src: `https://player.vimeo.com/video/${vimeo[1]}` };
  if (/^https?:\/\//i.test(u)) return { tipo: "arquivo", src: u };
  return null;
};
